<template>
<g id="Dial_A-06">
	<path fill="#FFFFFF" stroke="#231F20" stroke-width="0.1" d="M118.8551,110.0079c0,25.8313-20.9404,46.7717-46.7717,46.7717s-46.7717-20.9404-46.7717-46.7717
		s20.9404-46.7717,46.7717-46.7717S118.8551,84.1767,118.8551,110.0079L118.8551,110.0079z M72.0834,107.7036
		c-1.2727,0-2.3044,1.0317-2.3044,2.3044s1.0317,2.3044,2.3044,2.3044s2.3044-1.0317,2.3044-2.3044l0,0
		C74.3878,108.7353,73.3561,107.7036,72.0834,107.7036z M104.8234,107.1723h-7.6536v5.6693h7.6536V107.1723L104.8234,107.1723z
		 M82.7134,107.1582v5.699h13.4648v-5.699H82.7134z"/>
	<g id="Dial_ring">
    <linearGradient id="Dial_ring-2_1_A-06" gradientUnits="userSpaceOnUse" x1="95.4708" y1="454.7053" x2="48.696" y2="535.7216" gradientTransform="matrix(1 0 0 1 0 -385.2055)">
			<stop  offset="0" style="stop-color:whitesmoke"/>
			<stop  offset="1" style="stop-color:#FFFFFF"/>
		</linearGradient>
		<path id="Dial_ring-2" fill="url(#Dial_ring-2_1_A-06)" stroke="#B3B4B7" stroke-width="0.0133" stroke-miterlimit="1" d="
			M118.8504,110.0079c0,25.8287-20.9383,46.767-46.767,46.767s-46.767-20.9383-46.767-46.767s20.9383-46.767,46.767-46.767
			S118.8504,84.1793,118.8504,110.0079L118.8504,110.0079z M72.0834,68.9097c-22.698,0-41.0983,18.4003-41.0983,41.0983
			s18.4003,41.0983,41.0983,41.0983s41.0983-18.4003,41.0983-41.0983l0,0c0.0001-22.6979-18.4002-41.0983-41.0981-41.0983
			C72.0835,68.9096,72.0834,68.9096,72.0834,68.9097z"/>
    <circle id="Outer_shoulder" fill="none" stroke="#B3B4B7" stroke-width="0.0333" stroke-miterlimit="10" cx="72.0834" cy="110.0079" r="46.767"/>
    <circle id="Inner_shoulder" fill="none" stroke="#767779" stroke-width="0.0333" stroke-miterlimit="1" cx="72.0834" cy="110.0079" r="41.0982"/>
	</g>
	<g id="Sec_v3_">
		<g id="Sec-Ticks">

				<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="67.3707" y1="64.8528" x2="67.6468" y2="67.4713"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="62.6819" y1="65.5961" x2="63.2295" y2="68.1706"/>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="58.0949" y1="66.8251" x2="58.9087" y2="69.3289"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="86.1311" y1="153.1075" x2="85.3173" y2="150.6035"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="53.6627" y1="68.5257" x2="54.7343" y2="70.9317"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="90.5627" y1="151.4059" x2="89.4931" y2="149.0011"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="45.451" y1="73.267" x2="46.9979" y2="75.3973"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="98.7757" y1="146.6647" x2="97.2282" y2="144.5338"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="41.7616" y1="76.2551" x2="43.5234" y2="78.2118"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="102.4664" y1="143.6754" x2="100.704" y2="141.7202"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="38.4032" y1="79.6125" x2="40.3609" y2="81.3743"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="105.8222" y1="140.3176" x2="103.8664" y2="138.5553"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="35.4165" y1="83.3018" x2="37.5454" y2="84.8502"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="108.8115" y1="136.6275" x2="106.68" y2="135.08"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="30.6733" y1="91.5145" x2="33.0789" y2="92.5858"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="113.5528" y1="128.416" x2="111.1478" y2="127.3439"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="28.9725" y1="95.9474" x2="31.4764" y2="96.7612"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="115.2542" y1="123.9834" x2="112.7503" y2="123.1685"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="27.7425" y1="100.5332" x2="30.3194" y2="101.0804"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="116.4828" y1="119.3963" x2="113.9067" y2="118.8481"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="27.0003" y1="105.2231" x2="29.6188" y2="105.498"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="117.2251" y1="114.7065" x2="114.6079" y2="114.4314"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="27.0003" y1="114.7056" x2="29.6188" y2="114.4308"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="117.2251" y1="105.2231" x2="114.6079" y2="105.498"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="27.7425" y1="119.3953" x2="30.3194" y2="118.8481"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="116.4809" y1="100.5342" x2="113.9067" y2="101.0804"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="28.9712" y1="123.9814" x2="31.4751" y2="123.1685"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="115.2522" y1="95.9474" x2="112.7503" y2="96.7603"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="30.6733" y1="128.4139" x2="33.0782" y2="127.3439"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="113.5528" y1="91.5145" x2="111.1478" y2="92.5849"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="35.4146" y1="136.627" x2="37.5454" y2="135.0795"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="108.8096" y1="83.3018" x2="106.68" y2="84.8491"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="38.4013" y1="140.3176" x2="40.3589" y2="138.5553"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="105.8222" y1="79.6115" x2="103.8645" y2="81.3733"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="41.7597" y1="143.674" x2="43.5214" y2="141.7184"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="102.4646" y1="76.2549" x2="100.7029" y2="78.2106"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="45.4495" y1="146.6629" x2="46.9971" y2="144.5322"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="98.7739" y1="73.2659" x2="97.2264" y2="75.3951"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="53.6612" y1="151.4043" x2="54.7329" y2="148.9993"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="90.5628" y1="68.5245" x2="89.4912" y2="70.9296"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="58.0942" y1="153.1057" x2="58.908" y2="150.6019"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="86.1299" y1="66.8232" x2="85.3161" y2="69.3267"/>
			</g>

				<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="81.5441" y1="65.5941" x2="80.996" y2="68.169"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="76.8533" y1="64.8509" x2="76.5773" y2="67.4694"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="67.3707" y1="155.1629" x2="67.6468" y2="152.5444"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="62.6819" y1="154.4196" x2="63.2295" y2="151.8452"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="81.5441" y1="154.4216" x2="80.996" y2="151.8467"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="76.8533" y1="155.1648" x2="76.5773" y2="152.5463"/>
		</g>
		<g id="Indices">

				<rect x="70.0932" y="64.6429" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="3.9505" height="2.6335"/>

				<rect x="70.0932" y="152.741" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="3.9505" height="2.6328"/>

				<rect x="26.7035" y="108.0329" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6321" height="3.9505"/>

				<rect x="114.798" y="108.0329" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6341" height="3.9505"/>

				<rect x="48.7716" y="70.5428" transform="matrix(0.8659 -0.5002 0.5002 0.8659 -29.2278 34.6902)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6334" height="2.6327"/>

				<rect x="92.8195" y="146.8392" transform="matrix(0.8662 -0.4997 0.4997 0.8662 -61.4381 66.8631)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.633" height="2.634"/>

				<rect x="32.6483" y="86.6703" transform="matrix(0.4997 -0.8662 0.8662 0.4997 -59.2216 73.4405)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6335" height="2.6336"/>

				<rect x="108.945" y="130.7173" transform="matrix(0.5006 -0.8657 0.8657 0.5006 -59.2341 161.3911)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6337" height="2.6337"/>

				<rect x="32.6444" y="130.7114" transform="matrix(0.8662 -0.4996 0.4996 0.8662 -61.4218 34.6275)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6333" height="2.6331"/>

				<rect x="108.9369" y="86.6668" transform="matrix(0.8661 -0.4998 0.4998 0.8661 -29.216 66.8852)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6344" height="2.6331"/>

				<rect x="48.775" y="146.8368" transform="matrix(0.4999 -0.8661 0.8661 0.4999 -103.2627 117.476)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6325" height="2.633"/>

				<rect x="92.8186" y="70.5464" transform="matrix(0.5002 -0.8659 0.8659 0.5002 -15.1781 117.4296)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6341" height="2.6331"/>
		</g>
		<g>
			<g>
				<path fill="#231F20" d="M59.9207,147.2793l-0.1-0.1162c-0.0523-0.0564-0.0931-0.1225-0.12-0.1945
					c-0.0179-0.0572-0.017-0.1185,0.0024-0.1752c0.0244-0.0841,0.0848-0.1531,0.1651-0.1882
					c0.0863-0.036,0.183-0.0376,0.2705-0.0046c0.0937,0.0298,0.176,0.0875,0.2358,0.1655l-0.0607,0.1854
					c-0.0451-0.0959-0.1266-0.1697-0.2265-0.2051c-0.0459-0.0172-0.0961-0.0193-0.1433-0.0059
					c-0.0391,0.01-0.0703,0.0395-0.0825,0.078c-0.0113,0.0357-0.009,0.0743,0.0066,0.1084c0.0228,0.0492,0.0536,0.0943,0.091,0.1336
					l0.1,0.1143c0.1044,0.0988,0.1451,0.2476,0.1055,0.3858c-0.0244,0.0852-0.0845,0.1558-0.1647,0.1935
					c-0.0846,0.0371-0.1803,0.0397-0.2668,0.0073c-0.1117-0.0356-0.2083-0.1075-0.2745-0.2043l0.068-0.2075
					c0.0361,0.1244,0.1297,0.2239,0.2517,0.2676c0.0457,0.017,0.096,0.0167,0.1415-0.0008c0.0411-0.015,0.0729-0.0483,0.0861-0.09
					C60.0225,147.4348,59.9902,147.3412,59.9207,147.2793z"/>
				<path fill="#231F20" d="M62.0462,147.1906l0.1648,0.0478l-0.8016,1.0229l-0.0362-0.0107l-0.1053-1.0469l-0.6525,0.8272
					l-0.0356-0.01l-0.1292-1.2925l0.1664,0.0482l0.0875,0.8866l0.55-0.7018l0.1563,0.0452l0.0909,0.888L62.0462,147.1906z"/>
				<path fill="#231F20" d="M62.3176,147.2551l0.166,0.0429l-0.3009,1.1623l-0.1659-0.0433L62.3176,147.2551z"/>
				<path fill="#231F20" d="M62.8427,148.1062l-0.1081-0.1079c-0.0566-0.0523-0.1026-0.1151-0.1354-0.1848
					c-0.0224-0.0555-0.0261-0.1168-0.0107-0.1746c0.0176-0.086,0.0726-0.1596,0.15-0.2009
					c0.0832-0.0422,0.1794-0.0514,0.2691-0.0257c0.0958,0.0227,0.1824,0.0741,0.2483,0.1472l-0.0461,0.19
					c-0.0524-0.0922-0.1395-0.1596-0.2418-0.1874c-0.0473-0.0135-0.0976-0.0114-0.1436,0.0059
					c-0.038,0.013-0.0668,0.0445-0.0762,0.0836c-0.0084,0.0366-0.003,0.0751,0.0151,0.108c0.0266,0.0472,0.0608,0.0898,0.101,0.1261
					l0.11,0.1061c0.1117,0.0904,0.1636,0.2357,0.1345,0.3764c-0.0176,0.0867-0.0718,0.1616-0.1488,0.2053
					c-0.0814,0.0438-0.1767,0.054-0.2655,0.0284c-0.114-0.0268-0.2158-0.091-0.2891-0.1823l0.0511-0.2122
					c0.0459,0.1212,0.1469,0.2131,0.2718,0.2475c0.0469,0.0132,0.0971,0.0088,0.141-0.0123c0.04-0.018,0.0692-0.0538,0.0789-0.0965
					C62.9573,148.2533,62.9173,148.1623,62.8427,148.1062z"/>
				<path fill="#231F20" d="M63.6266,148.2872l-0.11-0.1055c-0.0576-0.0512-0.1049-0.1129-0.1393-0.1819
					c-0.0233-0.0551-0.0283-0.1161-0.0144-0.1743c0.016-0.0861,0.0693-0.1608,0.1455-0.204
					c0.0824-0.0441,0.1784-0.0552,0.2687-0.031c0.0962,0.0205,0.1839,0.0699,0.2512,0.1416l-0.042,0.19
					c-0.0545-0.0909-0.143-0.1564-0.2459-0.182c-0.0474-0.0124-0.0975-0.0095-0.1432,0.0082
					c-0.0378,0.0141-0.0659,0.0464-0.0745,0.0858c-0.0074,0.0367-0.0013,0.0749,0.0171,0.1075
					c0.0278,0.0467,0.063,0.0887,0.1042,0.1242l0.1115,0.1036c0.1134,0.0883,0.1683,0.2323,0.1423,0.3737
					c-0.0159,0.0871-0.0687,0.1631-0.1449,0.2083c-0.0804,0.0456-0.1755,0.0577-0.2647,0.0337
					c-0.1146-0.0245-0.2178-0.0866-0.293-0.1765l0.0469-0.213c0.0484,0.1201,0.1512,0.2099,0.2767,0.2418
					c0.0474,0.0121,0.0975,0.0068,0.1413-0.0149c0.0393-0.0192,0.0675-0.0555,0.0764-0.0983
					C63.7518,148.4525,63.7156,148.3737,63.6266,148.2872z"/>
			</g>
			<g>
				<path fill="#231F20" d="M81.1806,147.4292l0.1565-0.0364l0.27,1.17l-0.1684,0.0389l-0.21-0.91l-0.2556,0.5351l-0.031,0.0072
					l-0.4678-0.3681l0.21,0.91l-0.1671,0.0385l-0.27-1.1694l0.1585-0.0366l0.4995,0.3906L81.1806,147.4292z"/>
				<path fill="#231F20" d="M81.9161,147.2343l0.1172-0.031l0.8292,1.03l-0.17,0.0451l-0.2456-0.3031l-0.4951,0.1312l-0.0541,0.3821
					l-0.1706,0.0454L81.9161,147.2343z M82.339,147.845l-0.2985-0.37l-0.0623,0.466L82.339,147.845z"/>
				<path fill="#231F20" d="M82.9909,148.1938l-0.3429-1.1487l0.3874-0.1157c0.1258-0.044,0.2602-0.058,0.3924-0.0406
					c0.1049,0.0196,0.2019,0.0689,0.2794,0.1422c0.0803,0.0743,0.1389,0.1691,0.1695,0.2741
					c0.0229,0.0756,0.0302,0.1552,0.0213,0.2337c-0.0081,0.0786-0.0325,0.1546-0.0715,0.2232
					c-0.0392,0.0713-0.093,0.1336-0.1578,0.1828c-0.0338,0.027-0.0704,0.0503-0.1092,0.0694
					c-0.0665,0.0283-0.1349,0.0518-0.2047,0.0706L82.9909,148.1938z M83.0618,147.0811l-0.2056,0.0616l0.2558,0.8551l0.21-0.0627
					c0.0649-0.0176,0.1276-0.0425,0.187-0.074c0.0368-0.0212,0.0707-0.0471,0.1009-0.077c0.0255-0.0266,0.0472-0.0565,0.0646-0.089
					c0.0569-0.1074,0.0673-0.2334,0.0288-0.3486c-0.0436-0.1608-0.1782-0.2804-0.343-0.3047
					c-0.041-0.0067-0.0827-0.0077-0.124-0.003C83.1771,147.0486,83.1188,147.0627,83.0618,147.0811z"/>
				<path fill="#231F20" d="M83.8737,146.6729l0.6463-0.2126l0.048,0.1452l-0.4834,0.1588l0.1145,0.3479l0.4666-0.1537l0.048,0.1461
					l-0.4666,0.1535l0.1165,0.3543l0.4988-0.1641l0.0477,0.1452l-0.6617,0.2179L83.8737,146.6729z"/>
			</g>
		</g>
	</g>
	<g id="Numerals">
		<g>
			<path fill="#231F20" d="M51.7663,76.6172h1.0286v7.185h-1.0286V76.6172z"/>
			<path fill="#231F20" d="M55.2422,76.6172h1.0287v7.185h-1.0287V76.6172z"/>
		</g>
		<g>
			<path fill="#231F20" d="M39.0097,89.6105h1.0285v7.185h-1.0285V89.6105z"/>
			<path fill="#231F20" d="M43.5152,89.5179c0.6931,0.0202,1.3196,0.4178,1.633,1.0363c0.8606,1.6583,0.8606,3.6317,0,5.29
				c-0.4796,0.9283-1.6209,1.292-2.5492,0.8124c-0.3414-0.1764-0.621-0.4525-0.8016-0.7917
				c-0.8508-1.6733-0.843-3.654,0.0207-5.3206C42.1548,89.9188,42.8048,89.5257,43.5152,89.5179z M43.5252,90.4952h-0.0514
				c-0.4327,0.0266-0.8051,0.3153-0.9387,0.7277c-0.2577,0.6244-0.3762,1.2975-0.3471,1.9724
				c-0.0303,0.6835,0.0856,1.3655,0.34,2.0006c0.1352,0.5184,0.665,0.829,1.1834,0.6938c0.3398-0.0886,0.6052-0.354,0.6938-0.6938
				c0.2562-0.624,0.3738-1.2961,0.3447-1.97c0.0273-0.6791-0.0857-1.3565-0.3319-1.99c-0.2213-0.4939-0.5189-0.7407-0.8926-0.7407
				H43.5252z"/>
		</g>
		<path fill="#231F20" d="M36.0026,113.5504l-0.6326-0.7457c0.5259-0.3314,0.9962-0.7436,1.3937-1.2215
			c0.3702-0.427,0.6424-0.93,0.7973-1.4736c-0.3459,0.2078-0.7436,0.313-1.147,0.3035c-0.5361,0.0054-1.0493-0.2171-1.4118-0.6121
			c-0.7999-0.8416-0.7828-2.1676,0.0386-2.9882c0.4038-0.409,0.958-0.634,1.5327-0.6223c0.6378-0.0181,1.2499,0.252,1.6664,0.7354
			c0.4447,0.5259,0.676,1.1994,0.6481,1.8876c-0.0203,0.9388-0.3017,1.8533-0.8127,2.6411
			C37.5657,112.3119,36.8541,113.0314,36.0026,113.5504z M37.7615,109.0862c0.0307-0.177,0.0514-0.3556,0.0618-0.5349
			c0.0153-0.3709-0.1085-0.7341-0.3473-1.0183c-0.2224-0.26-0.5503-0.4056-0.8923-0.3961
			c-0.3103-0.0091-0.6101,0.1133-0.8254,0.3369c-0.2185,0.2264-0.3363,0.5316-0.3266,0.8461
			c-0.002,0.3074,0.1271,0.6011,0.3549,0.8075c0.226,0.2222,0.5317,0.3447,0.8486,0.34
			C37.041,109.46,37.4346,109.3268,37.7615,109.0862z"/>
		<path fill="#231F20" d="M41.1468,122.9184c0.2694-0.0006,0.5363,0.0515,0.7857,0.1533c0.2469,0.0989,0.4735,0.2425,0.6684,0.4234
			c0.1928,0.1788,0.3488,0.3937,0.4591,0.6324c0.1121,0.2411,0.1696,0.5041,0.1684,0.77c0.0057,0.5242-0.2134,1.0258-0.6019,1.3778
			c0.3057,0.2081,0.5632,0.4795,0.7549,0.7958c0.1668,0.2993,0.2513,0.6374,0.2449,0.98c0.0017,0.2924-0.0665,0.581-0.1988,0.8417
			c-0.1335,0.2629-0.3152,0.4983-0.5358,0.6939c-0.2309,0.2046-0.4971,0.3655-0.7857,0.4746
			c-0.3028,0.1162-0.6246,0.175-0.9489,0.1734c-0.3313,0.0029-0.6602-0.0559-0.97-0.1734
			c-0.2877-0.1086-0.5537-0.2675-0.7857-0.4694c-0.2216-0.1934-0.402-0.4294-0.5305-0.6939
			c-0.129-0.2636-0.1954-0.5534-0.194-0.8469c-0.0118-0.6146,0.2636-1.1995,0.7449-1.5819
			c0.0705-0.0676,0.1494-0.1259,0.2348-0.1734c-0.3807-0.366-0.5978-0.8699-0.6022-1.398c-0.0012-0.2659,0.0564-0.5289,0.1685-0.77
			c0.1083-0.2359,0.2607-0.4489,0.449-0.6275c0.1932-0.1806,0.418-0.3241,0.6631-0.4235
			C40.5924,122.9709,40.8684,122.917,41.1468,122.9184z M41.1468,126.745c-0.1841,0.0001-0.367,0.0311-0.5408,0.0918
			c-0.1687,0.0568-0.3259,0.1432-0.4643,0.2552c-0.1312,0.1072-0.2404,0.2388-0.3214,0.3876
			c-0.0818,0.1503-0.124,0.3189-0.1225,0.49c-0.0017,0.1705,0.0386,0.3388,0.1173,0.49c0.0788,0.1504,0.1863,0.2839,0.3164,0.3929
			c0.1372,0.1149,0.2947,0.203,0.4643,0.26c0.1806,0.0618,0.3704,0.0928,0.5613,0.0918c0.1824,0.0002,0.3635-0.0309,0.5355-0.0918
			c0.1669-0.0574,0.3224-0.1437,0.4593-0.2551c0.1313-0.1071,0.2404-0.2388,0.3214-0.3877c0.0827-0.1535,0.1248-0.3256,0.1224-0.5
			c0.0015-0.1711-0.0406-0.3397-0.1224-0.49c-0.0819-0.1497-0.1928-0.2815-0.3264-0.3876c-0.2824-0.2222-0.6307-0.3443-0.99-0.347
			L41.1468,126.745z M41.9019,124.245c-0.2002-0.1984-0.4734-0.3054-0.7551-0.2958c-0.1524-0.0021-0.3035,0.0273-0.4439,0.0865
			c-0.1263,0.0537-0.2408,0.1319-0.3368,0.23c-0.0891,0.0912-0.16,0.1985-0.2091,0.3161c-0.0471,0.1132-0.0714,0.2346-0.0714,0.3573
			c-0.0005,0.1336,0.0273,0.2657,0.0817,0.3877c0.0526,0.1198,0.1269,0.2289,0.2193,0.3216
			c0.0952,0.094,0.2078,0.1685,0.3316,0.2194c0.136,0.0556,0.2817,0.0832,0.4286,0.0813c0.1381,0.001,0.275-0.025,0.4031-0.0765
			c0.1245-0.05,0.2386-0.1227,0.3367-0.2142c0.0977-0.0904,0.176-0.1998,0.23-0.3215c0.0549-0.1254,0.0827-0.2609,0.0815-0.3978
			C42.1916,124.6784,42.0856,124.4301,41.9019,124.245z"/>
		<path fill="#231F20" d="M51.9189,136.0723h4.65l-3.2514,7.2693l-0.92-0.3876l2.6276-5.8994h-3.1062
			C51.9189,137.0546,51.9189,136.0723,51.9189,136.0723z"/>
		<path fill="#231F20" d="M90.1515,135.7195h3.189v0.9156h-2.253v1.8155c0.0723-0.0068,0.1459-0.01,0.2214-0.01
			c0.634-0.0231,1.2515,0.2052,1.7179,0.6353c0.4466,0.4172,0.692,1.0064,0.6737,1.6173c0.023,0.6193-0.2192,1.219-0.6659,1.6486
			c-0.4681,0.4325-1.089,0.6609-1.7257,0.635c-0.5914-0.002-1.1736-0.1467-1.6971-0.4218v-1.0595
			c0.4454,0.3128,0.9728,0.4881,1.5168,0.5042c0.3968,0.0125,0.7843-0.1222,1.0877-0.3782
			c0.5115-0.4166,0.5884-1.1689,0.1718-1.6804c-0.0616-0.0756-0.1322-0.1434-0.2102-0.2018
			c-0.341-0.2628-0.763-0.3983-1.1932-0.3831c-0.2817-0.0183-0.5644,0.0166-0.8332,0.1028L90.1515,135.7195z"/>
		<path fill="#231F20" d="M104.6874,126.3165v1.1021h1.0608v1.03h-1.0611v1.7449h-1.0207v-1.7449h-2.9382l2.7548-5.49h1.1529
			l-2.2445,4.4591h1.2752v-1.1021L104.6874,126.3165z"/>
		<path fill="#231F20" d="M102.827,95.5725h2.7353v0.9925h-4.547v-0.0719l0.4323-0.5092c0.6757-0.8367,1.2132-1.5465,1.6124-2.1293
			c0.3019-0.4148,0.5637-0.8574,0.7818-1.3218c0.1179-0.2802,0.1798-0.5807,0.1823-0.8846
			c0.0171-0.3574-0.1065-0.7074-0.3444-0.9747c-0.238-0.2485-0.5714-0.3825-0.9152-0.3676c-0.302,0.004-0.5969,0.0921-0.8515,0.2545
			c-0.2967,0.1861-0.5529,0.4302-0.7532,0.7175v-1.3065c0.4774-0.4244,1.0892-0.6666,1.7277-0.6839
			c0.5822-0.0184,1.1451,0.2094,1.5506,0.6275c0.4101,0.4275,0.6301,1.0025,0.61,1.5945c-0.0042,0.3136-0.0553,0.6249-0.1517,0.9234
			c-0.1341,0.397-0.3145,0.7768-0.5377,1.1315c-0.3948,0.6127-0.8329,1.1963-1.3111,1.7464L102.827,95.5725z"/>
		<path fill="#231F20" d="M90.8903,76.6172h1.0292v7.1851h-1.0292V76.6172z"/>
		<g>
			<path fill="#231F20" d="M68.9796,71.7821h1.0286v7.185h-1.0286V71.7821z"/>
			<path fill="#231F20" d="M72.9824,77.9744h2.7346v0.9926h-4.5464v-0.072l0.4321-0.5092c0.6753-0.8366,1.2126-1.5464,1.6121-2.1293
				c0.3021-0.4147,0.5638-0.8573,0.7818-1.3217c0.1181-0.2801,0.1802-0.5807,0.1829-0.8847c0.017-0.3575-0.1069-0.7074-0.345-0.9746
				c-0.2378-0.2488-0.5715-0.3828-0.9153-0.3677c-0.3018,0.0041-0.5966,0.0922-0.8511,0.2545
				c-0.2968,0.1861-0.5531,0.4301-0.7535,0.7175v-1.3064c0.4776-0.4244,1.0896-0.6667,1.7283-0.684
				c0.5822-0.0184,1.1451,0.2094,1.5506,0.6275c0.4099,0.4275,0.6296,1.0026,0.6093,1.5945
				c-0.0042,0.3136-0.0553,0.6249-0.1517,0.9234c-0.1335,0.3972-0.3137,0.777-0.537,1.1316
				c-0.395,0.6125-0.8331,1.1961-1.311,1.7463L72.9824,77.9744z"/>
		</g>
		<path fill="#231F20" d="M72.7292,140.9679l0.1021-0.072l0.6224,0.7815c-0.5079,0.3198-0.9676,0.7104-1.3651,1.16
			c-0.3708,0.4349-0.6545,0.937-0.8358,1.479c0.3498-0.1877,0.7397-0.2883,1.1367-0.2933c0.5402-0.0107,1.0596,0.208,1.4294,0.6019
			c0.3848,0.3935,0.5944,0.9258,0.5813,1.476c0.0104,0.575-0.2188,1.1283-0.6328,1.5275c-0.4046,0.4113-0.9605,0.6382-1.5374,0.6275
			c-0.6256,0.0218-1.2275-0.24-1.6381-0.7125c-0.4331-0.522-0.6559-1.1868-0.6248-1.8643c0.0022-0.5881,0.1111-1.1708,0.3214-1.72
			c0.2202-0.5813,0.5328-1.1233,0.9257-1.6049C71.6517,141.8235,72.1617,141.3568,72.7292,140.9679z M71.0316,145.3807
			c-0.0287,0.1785-0.0424,0.3592-0.041,0.54c-0.0142,0.3653,0.1118,0.7222,0.3522,0.9976c0.228,0.2578,0.5587,0.401,0.9027,0.3909
			c0.3068,0.0092,0.6031-0.1123,0.815-0.3343c0.2159-0.2266,0.3318-0.5305,0.3216-0.8433c0.0123-0.3166-0.1125-0.6231-0.3425-0.841
			c-0.2469-0.2213-0.571-0.3367-0.9022-0.3213c-0.1778-0.0025-0.3547,0.0271-0.522,0.0873
			C71.4091,145.1422,71.2133,145.251,71.0316,145.3807L71.0316,145.3807z"/>
	</g>
	<g id="S_Logo">
		<g id="Printed">
			<path fill="#231F20" d="M66.4714,93.0522c0.8578,0.0622,1.069,0.17,1.069,0.8338c0,0.48,0.0186,0.95-1.2539,0.95
				c-0.7386,0-1.2285-0.0153-1.2285-0.9652h0.7409c0,0.3008,0.1081,0.3327,0.4876,0.3327c0.3627,0,0.4815-0.0241,0.4815-0.2666
				c0-0.2518-0.0427-0.2476-0.4053-0.2707l-0.17-0.0112c-0.7139-0.05-1.1315-0.0466-1.1315-0.8768s0.4674-0.8828,1.2252-0.8828
				c0.6315,0,1.1722,0.01,1.1722,0.81v0.12h-0.74c0-0.2972-0.1237-0.2972-0.4323-0.2972c-0.4179,0-0.4535,0.085-0.4535,0.2464
				c0,0.2324,0.1117,0.24,0.3178,0.2546L66.4714,93.0522z"/>
			<path fill="#231F20" d="M71.3552,91.9165h0.7754l-0.64,2.8961h-1.1172l-0.3938-1.8145h-0.03l-0.4219,1.8145h-1.1028
				l-0.625-2.8961h0.7822l0.4173,2.2324h0.027l0.5446-2.2324h0.8024l0.52,2.2324h0.0244L71.3552,91.9165z"/>
			<path fill="#231F20" d="M73.2638,94.8127h-0.7742v-2.8961h0.7742V94.8127z"/>
			<path fill="#231F20" d="M75.211,93.0522c0.8581,0.0622,1.0693,0.17,1.0693,0.8338c0,0.48,0.0209,0.95-1.2529,0.95
				c-0.7379,0-1.23-0.0153-1.23-0.9652h0.7425c0,0.3008,0.1071,0.3327,0.487,0.3327c0.3627,0,0.4834-0.0241,0.4834-0.2666
				c0-0.2518-0.0433-0.2476-0.4078-0.2707l-0.1693-0.0112c-0.7139-0.05-1.13-0.0466-1.13-0.8768s0.4658-0.8828,1.2239-0.8828
				c0.6316,0,1.1726,0.01,1.1726,0.81v0.12h-0.741c0-0.2972-0.1243-0.2972-0.4316-0.2972c-0.4179,0-0.4531,0.085-0.4531,0.2464
				c0,0.2324,0.1126,0.24,0.3174,0.2546L75.211,93.0522z"/>
			<path fill="#231F20" d="M78.1306,93.0522c0.8568,0.0622,1.0687,0.17,1.0687,0.8338c0,0.48,0.02,0.95-1.2543,0.95
				c-0.7366,0-1.2271-0.0153-1.2271-0.9652h0.74c0,0.3008,0.1094,0.3327,0.4869,0.3327c0.3627,0,0.4828-0.0241,0.4828-0.2666
				c0-0.2518-0.042-0.2476-0.4046-0.2707l-0.1712-0.0112c-0.7133-0.05-1.13-0.0466-1.13-0.8768s0.4677-0.8828,1.2235-0.8828
				c0.6342,0,1.1739,0.01,1.1739,0.81v0.12h-0.7416c0-0.2972-0.1236-0.2972-0.4323-0.2972c-0.4159,0-0.4508,0.085-0.4508,0.2464
				c0,0.2324,0.1117,0.24,0.3145,0.2546L78.1306,93.0522z"/>
			<path fill="#231F20" d="M65.3793,98.284v-2.83h1.5937c0.3549-0.0415,0.7123,0.0542,0.9991,0.2674
				c0.2109,0.2975,0.3046,0.6624,0.263,1.0247c0.0423,0.4238-0.039,0.8508-0.2341,1.2294c-0.2459,0.2406-0.589,0.3545-0.93,0.3086
				L65.3793,98.284z M65.7676,98.0139h1.1221c0.2818,0.0388,0.5676-0.0339,0.7965-0.2027c0.1519-0.2763,0.2138-0.5931,0.1771-0.9062
				c0.0353-0.3333-0.0177-0.67-0.1536-0.9764c-0.1038-0.1375-0.3506-0.2054-0.7419-0.2054h-1.2L65.7676,98.0139z"/>
			<path fill="#231F20" d="M69.2082,95.7231v0.9645h1.7471v0.2689h-1.7471v1.0573h1.8233v0.27h-2.2121v-2.83h2.2116v0.2692
				L69.2082,95.7231z"/>
			<path fill="#231F20" d="M72.1234,95.4538v2.5334h1.7692v0.2967h-2.1569v-2.83L72.1234,95.4538z"/>
			<path fill="#231F20" d="M75.129,95.7504v2.5336h-0.3887v-2.5336h-1.1208v-0.2965H76.24v0.2965H75.129z"/>
			<path fill="#231F20" d="M78.4945,97.6846h-1.7428l-0.2636,0.5993h-0.41l1.26-2.83h0.5449l1.2842,2.83h-0.4059L78.4945,97.6846z
				 M78.381,97.4439l-0.7624-1.7295l-0.7553,1.7295H78.381z"/>
		</g>
		<g id="Logo">
			<path fill="none" d="M76.1182,88.7585c-0.0714-0.1892-0.2071-0.5209-0.2725-0.6763c-0.6621-1.5546-1.5182-3.0193-2.5479-4.3591
				c-0.0482-0.0636-0.14-0.1805-0.2252-0.2879c-0.0433-0.0544-0.0841-0.1057-0.1208-0.1472
				c-0.0274-0.0365-0.0571-0.0711-0.0889-0.1038c-0.3346-0.3159-0.8371-0.3744-1.2353-0.1437
				c-0.0636,0.0365-0.1226,0.0805-0.1758,0.1309c-0.019,0.0152-0.0363,0.0324-0.0517,0.0512
				c-0.1068,0.1231-0.3422,0.4334-0.4161,0.5295c-0.5323,0.6911-1.0177,1.4172-1.4528,2.1733
				c-0.4339,0.751-0.8181,1.5297-1.15,2.3311c-0.0258,0.0628-0.08,0.1909-0.1289,0.3044c-0.0241,0.0568-0.0482,0.1108-0.0644,0.1513
				c-0.0192,0.0448-0.028,0.0661-0.0352,0.0858c-0.0456,0.1177-0.0689,0.2428-0.0686,0.369
				c0.0002,0.4565,0.2976,0.8596,0.7337,0.9945c0.0801,0.0233,0.1627,0.0374,0.246,0.042c1.015,0.1615,2.0413,0.2414,3.069,0.2389
				c0.6785,0.0004,1.3565-0.0334,2.0316-0.1014c0.194-0.02,0.79-0.092,1.2158-0.1607c0.2858-0.0571,0.5315-0.2382,0.6707-0.4943
				c0.0185-0.0334,0.0272-0.0532,0.0306-0.061l0.0016-0.0008v-0.0025l0.0019-0.0027c0.0052-0.01,0.0136-0.0275,0.0257-0.0541
				c0.0572-0.1327,0.087-0.2755,0.0876-0.42c0.0003-0.0779-0.009-0.1555-0.0277-0.2311
				C76.1565,88.861,76.1389,88.8091,76.1182,88.7585z M75.6588,89.3672l-0.0016,0.0024v0.0026l-0.014,0.0287l-0.0028,0.0083
				l-0.0151,0.03c-0.0656,0.1289-0.1847,0.2224-0.3255,0.2554c-0.4063,0.0661-1.0049,0.1376-1.1842,0.1565
				c-0.6589,0.0671-1.3209,0.1005-1.9832,0.1c-1.006,0.0022-2.0106-0.076-3.0042-0.2339l-0.0124-0.0034h-0.0157
				c-0.0467-0.0015-0.093-0.009-0.1377-0.0224c-0.2294-0.0715-0.3859-0.2838-0.3863-0.5241
				c-0.0003-0.0659,0.0118-0.1314,0.0358-0.1928v-0.0009c0.0189-0.0438,0.1712-0.3994,0.2253-0.5295
				c0.6505-1.5678,1.5032-3.0439,2.5364-4.3906c0.0419-0.0566,0.1393-0.1822,0.2311-0.2993c0.0449-0.0577,0.09-0.1135,0.123-0.1555
				c0.0193-0.0224,0.032-0.04,0.044-0.0526l0.01-0.011c0.0287-0.026,0.0599-0.049,0.0932-0.0686
				c0.209-0.1201,0.4718-0.0902,0.6484,0.0738c0.015,0.0146,0.0961,0.1143,0.1722,0.2106c0.0817,0.1031,0.168,0.214,0.2142,0.2723
				c1.0045,1.3062,1.8394,2.7345,2.4845,4.2507c0.0413,0.0981,0.1152,0.2795,0.1806,0.4418
				c0.0326,0.0818,0.0632,0.1593,0.0846,0.2187c0.0114,0.0291,0.02,0.0548,0.027,0.0719l0.0066,0.0208v0.0018
				c0.0089,0.0383,0.0135,0.0774,0.0139,0.1167C75.7061,89.222,75.6897,89.2974,75.6588,89.3672L75.6588,89.3672z"/>
			<path fill="#231F20" d="M76.3082,88.8833c-0.0159-0.0587-0.0351-0.1164-0.0576-0.1729
				c-0.0726-0.1941-0.2089-0.5254-0.2738-0.6836c-0.3212-0.7525-0.6875-1.485-1.0969-2.1935
				c-0.4407-0.764-0.9321-1.4977-1.4708-2.1961c-0.0492-0.0645-0.1392-0.1817-0.2281-0.29c-0.0408-0.0542-0.0841-0.1064-0.12-0.15
				c-0.0308-0.0406-0.0646-0.0788-0.1012-0.1142c-0.2194-0.2076-0.5099-0.3232-0.8119-0.3232h-0.0016
				c-0.2071,0.0004-0.4105,0.0549-0.59,0.1582c-0.0715,0.0423-0.1385,0.0918-0.2,0.1476l-0.108,0.1l0.0078,0.01
				c-0.1224,0.1476-0.3174,0.4039-0.3848,0.4907c-1.0684,1.3909-1.9493,2.9162-2.62,4.5368c-0.026,0.0612-0.08,0.1891-0.1285,0.3026
				c-0.0248,0.0562-0.0476,0.11-0.0655,0.1513c-0.0173,0.0432-0.0277,0.0663-0.0378,0.0894
				c-0.2314,0.611,0.0763,1.2939,0.6873,1.5253c0.0229,0.0087,0.0461,0.0166,0.0695,0.0239
				c0.0882,0.0263,0.1791,0.0427,0.2709,0.049c1.0203,0.1607,2.0517,0.2405,3.0846,0.2389
				c0.6838,0.0005,1.3671-0.0343,2.0473-0.1042c0.1962-0.0195,0.7907-0.0909,1.2232-0.1614
				c0.3276-0.0625,0.6099-0.2685,0.7693-0.5614c0.012-0.0213,0.02-0.0378,0.0257-0.05l0.0068-0.0147l0.0016-0.0052l0.0036-0.0032
				v-0.0036l0.002-0.0024c0.01-0.019,0.0188-0.0385,0.0263-0.0586c0.0668-0.149,0.1012-0.3104,0.101-0.4737
				C76.3388,89.057,76.3286,88.9691,76.3082,88.8833z M76.1106,89.5649c-0.0121,0.0266-0.02,0.044-0.0257,0.0541l-0.0019,0.0027
				v0.0025l-0.0016,0.0008c-0.0034,0.0078-0.0121,0.0276-0.0306,0.061c-0.1392,0.2561-0.3849,0.4372-0.6707,0.4943
				c-0.4257,0.0687-1.0218,0.14-1.2158,0.1607c-0.6751,0.068-1.3531,0.1018-2.0316,0.1014c-1.0277,0.0025-2.054-0.0774-3.069-0.2389
				c-0.0833-0.0046-0.1659-0.0187-0.246-0.042c-0.4361-0.1349-0.7335-0.538-0.7337-0.9945c-0.0003-0.1262,0.023-0.2513,0.0686-0.369
				c0.0072-0.02,0.016-0.041,0.0352-0.0858c0.0162-0.04,0.04-0.0945,0.0644-0.1513c0.0492-0.1135,0.1031-0.2416,0.1289-0.3044
				c0.3319-0.8014,0.7161-1.5801,1.15-2.3311c0.4351-0.7561,0.9205-1.4822,1.4528-2.1733c0.0739-0.0961,0.3093-0.4064,0.4161-0.5295
				c0.0154-0.0188,0.0327-0.036,0.0517-0.0512c0.0532-0.0504,0.1122-0.0944,0.1758-0.1309
				c0.3982-0.2307,0.9007-0.1722,1.2353,0.1437c0.0318,0.0327,0.0615,0.0673,0.0889,0.1038
				c0.0367,0.0415,0.0775,0.0928,0.1208,0.1472c0.0852,0.1074,0.177,0.2243,0.2252,0.2879
				c1.0297,1.3398,1.8858,2.8045,2.5479,4.3591c0.0654,0.1554,0.2011,0.4871,0.2725,0.6763c0.0206,0.0507,0.038,0.1027,0.052,0.1557
				c0.0187,0.0756,0.028,0.1532,0.0277,0.2311c-0.0005,0.1443-0.0303,0.2871-0.0874,0.4196
				C76.1104,89.5649,76.1106,89.5649,76.1106,89.5649z M75.6927,89.0286c0.0089,0.0383,0.0135,0.0774,0.0139,0.1167
				c-0.0006,0.0764-0.0168,0.1519-0.0475,0.2219l-0.0016,0.0024v0.0026l-0.014,0.0287l-0.0028,0.0083l-0.0151,0.03
				c-0.0656,0.1289-0.1847,0.2224-0.3255,0.2554c-0.4063,0.0661-1.0049,0.1376-1.1842,0.1565
				c-0.6589,0.0671-1.3209,0.1005-1.9832,0.1c-1.0061,0.0022-2.0108-0.076-3.0045-0.2339l-0.0124-0.0034h-0.0157
				c-0.0467-0.0015-0.093-0.009-0.1377-0.0224c-0.2294-0.0715-0.3859-0.2838-0.3863-0.5241
				c-0.0003-0.0659,0.0118-0.1314,0.0358-0.1928v-0.0009c0.0189-0.0438,0.1712-0.3994,0.2253-0.5295
				c0.6505-1.5678,1.5032-3.0439,2.5364-4.3906c0.0419-0.0566,0.1393-0.1822,0.2311-0.2993c0.0449-0.0577,0.09-0.1135,0.123-0.1555
				c0.0193-0.0224,0.032-0.04,0.044-0.0526l0.01-0.011c0.0287-0.026,0.0599-0.049,0.0932-0.0686
				c0.209-0.1201,0.4718-0.0902,0.6484,0.0738c0.015,0.0146,0.0961,0.1143,0.1722,0.2106c0.0817,0.1031,0.168,0.214,0.2142,0.2723
				c1.0045,1.3062,1.8394,2.7345,2.4845,4.2507c0.0413,0.0981,0.1152,0.2795,0.1806,0.4418
				c0.0326,0.0818,0.0632,0.1593,0.0846,0.2187c0.0114,0.0291,0.02,0.0548,0.027,0.0719l0.0066,0.0208L75.6927,89.0286z"/>
			<polygon fill="#FFFFFF" points="74.1272,86.6963 72.7322,86.6963 72.7322,85.2803 71.5752,85.2803 71.5752,86.6963
				70.1582,86.6963 70.1582,87.8532 71.5752,87.8532 71.5752,89.2482 72.7322,89.2482 72.7322,87.8532 74.1272,87.8532 			"/>
		</g>
	</g>
	<g id="A-04DD">
		<g>
			<path fill="#231F20" d="M71.3519,128.3172h0.9v0.3525h-0.9V128.3172z"/>
			<path fill="#231F20" d="M73.3396,126.7561c0.2434,0.007,0.4635,0.1466,0.5735,0.3639c0.3026,0.5826,0.3026,1.2759,0,1.8585
				c-0.1685,0.3261-0.5694,0.4539-0.8955,0.2854c-0.12-0.062-0.2183-0.1591-0.2817-0.2783
				c-0.2986-0.5879-0.2959-1.2837,0.0074-1.8692C72.8617,126.8968,73.09,126.7588,73.3396,126.7561z M73.3432,127.0992H73.325
				c-0.1522,0.0091-0.2832,0.1107-0.33,0.2558c-0.0907,0.2193-0.1323,0.4558-0.1221,0.6929
				c-0.0106,0.2401,0.0303,0.4798,0.12,0.7028c0.0474,0.1821,0.2335,0.2913,0.4156,0.2438
				c0.1194-0.0311,0.2127-0.1244,0.2438-0.2438c0.09-0.2192,0.1314-0.4553,0.1211-0.692c0.0096-0.2386-0.0301-0.4766-0.1166-0.6992
				C73.579,127.1861,73.4744,127.0994,73.3432,127.0992z"/>
		</g>
		<path fill="#231F20" d="M75.3695,126.8113l0.035-0.0246l0.2132,0.2676c-0.174,0.1095-0.3314,0.2433-0.4676,0.3973
			c-0.127,0.1489-0.2242,0.3209-0.2863,0.5065c0.1199-0.0641,0.2534-0.0984,0.3894-0.1c0.1851-0.0038,0.3632,0.0711,0.49,0.2061
			c0.1318,0.1348,0.2036,0.3171,0.1991,0.5056c0.0036,0.1969-0.0749,0.3865-0.2167,0.5232
			c-0.1386,0.1409-0.3291,0.2187-0.5267,0.215c-0.2143,0.0074-0.4205-0.0823-0.5611-0.2441
			c-0.1484-0.1788-0.2247-0.4065-0.214-0.6386c0.0007-0.2014,0.038-0.4011,0.11-0.5892c0.0754-0.1992,0.1825-0.3849,0.3171-0.55
			C75.0006,127.1043,75.1752,126.9445,75.3695,126.8113z M74.7881,128.3228c-0.0099,0.0612-0.0146,0.123-0.0141,0.185
			c-0.0048,0.1251,0.0383,0.2473,0.1206,0.3417c0.0781,0.0883,0.1914,0.1373,0.3092,0.1339
			c0.1051,0.0032,0.2066-0.0385,0.2792-0.1145c0.0739-0.0777,0.1135-0.1817,0.11-0.2889c0.0042-0.1084-0.0386-0.2134-0.1173-0.2881
			c-0.0846-0.0758-0.1956-0.1153-0.3091-0.11c-0.0609-0.0008-0.1215,0.0093-0.1788,0.03
			C74.9172,128.2412,74.8503,128.2784,74.7881,128.3228L74.7881,128.3228z"/>
		<path fill="#231F20" d="M70.3902,128.7626h-1.56l-0.2383,0.5372h-0.3672l1.1289-2.5348h0.487l1.1516,2.5348h-0.363
			L70.3902,128.7626z M70.2874,128.5231l-0.6817-1.5472l-0.6751,1.5472H70.2874z"/>
	</g>
	<g id="_517_3H_Window">
		<polygon fill="#FFFFFF" points="104.8232,107.1722 105.6732,106.3223 105.6732,113.6933 104.8232,112.8412 		"/>
		<polygon fill="#E6E7E7" points="82.7132,107.1722 81.8642,106.3223 105.6732,106.3223 104.8232,107.1722 		"/>
		<polygon fill="#D0D2D3" points="82.7132,112.8412 81.8642,113.6933 81.8642,106.3223 82.7132,107.1722 		"/>
		<polygon fill="#FFFFFF" points="104.8232,112.8412 105.6732,113.6933 81.8642,113.6933 82.7132,112.8412 		"/>
		<polygon fill="#FFFFFF" points="96.1782,107.1732 96.1782,112.8423 96.6742,113.3402 96.6742,106.6772 		"/>
		<polygon fill="#D0D2D3" points="97.1702,107.1732 96.6742,106.6772 96.6742,113.3402 97.1702,112.8423 		"/>
	</g>
</g>
</template>
<script>
export default {
  name: 'sdDialA06',
};
</script>
